import React, { useState } from "react";
import { Card, Input, Button, List, Typography, Space, message, Divider } from "antd";
import { SendOutlined, RobotOutlined, UserOutlined } from "@ant-design/icons";
import axios from "axios";

const { TextArea } = Input;
const { Text, Title } = Typography;

export default function TestingClaude() {
  const [prompt, setPrompt] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!prompt.trim()) return;

    const userMessage = { role: "user", content: prompt };
    setMessages((prev) => [...prev, userMessage]);
    setPrompt("");
    setLoading(true);

    try {
      // Calling our backend proxy to avoid CORS issues and protect our API key
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/claude/message`,
        { prompt }
      );

      const assistantMessage = {
        role: "assistant",
        content: response.data.content[0].text,
      };
      setMessages((prev) => [...prev, assistantMessage]);
    } catch (error) {
      console.error("Error calling Claude API:", error);
      message.error("Error al llamar a la API de Claude. Revisa la consola para más detalles.");
      
      // Fallback message for debugging
      if (error.response) {
        console.error("Response data:", error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={2}>Claude API Testing</Title>
      <Divider />
      <Card style={{ marginBottom: "20px" }}>
        <List
          dataSource={messages}
          renderItem={(item) => (
            <List.Item style={{ borderBottom: "none", padding: "10px 0" }}>
              <Space align="start">
                {item.role === "user" ? (
                  <UserOutlined style={{ color: "#1890ff", fontSize: "20px" }} />
                ) : (
                  <RobotOutlined style={{ color: "#52c41a", fontSize: "20px" }} />
                )}
                <div>
                  <Text strong>{item.role === "user" ? "Tú: " : "Claude: "}</Text>
                  <div style={{ whiteSpace: "pre-wrap", marginTop: "5px" }}>{item.content}</div>
                </div>
              </Space>
            </List.Item>
          )}
          locale={{ emptyText: "Sin mensajes. ¡Empieza una conversación!" }}
        />
      </Card>

      <Card>
        <Space direction="vertical" style={{ width: "100%" }}>
          <TextArea
            rows={4}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Escribe algo para Claude..."
            disabled={loading}
          />
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={handleSend}
            loading={loading}
            block
          >
            Enviar a Claude
          </Button>
        </Space>
      </Card>
      
      <div style={{ marginTop: "20px" }}>
        <Text type="secondary">
          Esta vista es solo para pruebas técnicas de la integración con Anthropic.
        </Text>
      </div>
    </div>
  );
}
